import { Modifier } from "@/dto/modifier";

export const modifierDisplay = (modifiers: Modifier[]) => {
  const groupedModifiers = modifiers.reduce(
    (groupedModifiersMap: any, modifier: Modifier) => {
      const id = modifier.id;
      if (!id) return groupedModifiersMap;

      const quantity = modifier.quantity ?? 1;

      if (groupedModifiersMap[id]) {
        groupedModifiersMap[id].count += quantity;
      } else {
        groupedModifiersMap[id] = {
          name: modifier.name,
          count: quantity,
        };
      }
      return groupedModifiersMap;
    },
    {} as Record<string, { name?: string; count: number }>
  );

  const displayModifiers = Object.values(groupedModifiers)
    .map((group: any) => {
      if (group.count > 1) {
        return `${group.name} × ${group.count}`;
      }
      return group.name;
    })
    .join(", ");

  return displayModifiers;
};
